import React      from 'react';
import classNames from 'classnames';

import styles   from './RewardLabel.css';
import { Game } from '../../models/Game';
import { getBadgeByGame } from '../../constants/Badges';

type RewardLabelProps = {
    game: Game,
    size: 'small' | 'large';
};

export class RewardLabel extends React.PureComponent<RewardLabelProps> {
    render() {
        const { game, size } = this.props;
        const badge = getBadgeByGame(game.slug);

        if (!badge) {
            return null;
        }

        const src = size === 'small' ?
            'https://ams.cdn.arkadiumhosted.com/assets/arena-4/arena/heap/70-x-70-small.png' :
            'https://ams.cdn.arkadiumhosted.com/assets/arena-4/arena/heap/program%402x.png';
        return (
            <RewardLabelContainer size = {size} >
                <RewardLabelImg
                    src = {src}
                    width = "100%"
                    height = "auto"
                    alt = "RewardBadge"
                />
            </RewardLabelContainer>
        );
    }
}
const RewardLabelContainer = (props: { size: string, [key: string]: any }) => (
    <div className = {classNames(styles.rewardLabelContainer, { [styles.small]: props.size === 'small' })}>
        {props.children}
    </div>
);

const RewardLabelImg = (props: any) => <img {...props} />;
